/* RESPONSIBLE TEAM: team-pricing-and-packaging */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
/* eslint-disable ember/no-classic-classes */
import { alias, readOnly } from '@ember/object/computed';
import Component from '@ember/component';
export default Component.extend({
  tagName: 'td',
  classNames: ['table__cell'],

  // for InviteActionsAndErrorHandlingComponentBase
  invite: alias('row'),
  inviteeEmail: readOnly('invite.email'),
});
